export default "__VITE_ASSET__ac0168db__"